<script>
  import { fade } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  function remove() {
    dispatch("remove", { id });
  }
  function toggleStatus() {
    let newStatus = !complete;
    dispatch("toggle", {
      id,
      newStatus
    });
  }

  export let id; // document ID
  export let text;
  export let complete;
</script>

<style>
  li {
    display: flex;
    font-size: 1.2em;
    font-weight: bold;
    padding: 2px;
  }
  span {
    margin-right: auto;
  }
  .buttons {
    min-width: 90px;
  }
</style>

<li in:fade out:fade>

  {#if complete}
    <span class="has-text-success">{text}</span>
  {:else}
    <span>{text}</span>
  {/if}

  <div class="buttons has-addons">
    {#if complete}
      <button class="button is-success is-rounded" on:click={toggleStatus}>
        <span class="icon is-small">
          <i class="fas fa-check" />
        </span>
      </button>
    {:else}
      <button
        class="button is-info is-light is-rounded"
        on:click={toggleStatus}>
        <span class="icon is-small">
          <i class="fas fa-check" />
        </span>
      </button>
    {/if}

    <button class="button is-danger is-light" on:click={remove}>
      <span class="icon is-small">
        <i class="fas fa-trash" />
      </span>
    </button>
  </div>
</li>
